if (!window.__footerAccordionBound) {
  window.__footerAccordionBound = true;

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-footer-accordion-toggle]');
    if (!toggle) return;

    var accordion = toggle.closest('.footer-block__accordion');
    if (!accordion) return;

    var isOpen = accordion.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
}
